import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.172 18h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-10.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.5M11.672 11V6m-2 5h4m3 0h2",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};
export default SvgComponent;